// Footer.js
import React from 'react';

function Footer() {
  return (
    <footer className="footer footer-center p-4 bg-base-300 text-base-content">
      <aside>
        <p>Copyright © 2023 - All rights reserved by Nine Inspirex Private Limited</p>
        <p>                              Designed by TESRIBAN</p>
      </aside>
    </footer>
  );
}

export default Footer;
